import Papa from 'papaparse';
import getAipUrls from '../../../../config/getAipUrls';

const AIP_URLS = getAipUrls();

function addFile(file) {
	const { calcStart } = file;
	const { fileName, fileKey, startStn = calcStart } = file;
	return { filename: `${fileName}_gpsReadings.json`, startStn, fileKey };
}

function getMessage(cisview) {
	const {
		stationAlignment,
		job: {
			globalData: { MasterLST: masterLST = {} }
		}
	} = cisview;
	const {
		optionsByStationAlignmentType: {
			editable: { timeuuid: editableTimeUUID },
			static: { timeuuid: staticTimeUUID }
		}
	} = stationAlignment;

	const {
		additionalSurveys: {
			datFilesByTimeuuid: { [staticTimeUUID]: staticDatFiles } = {}
		} = {}
	} = cisview;

	const staticFiles = staticDatFiles.map(file => {
		return addFile(file);
	});

	const destFiles = Object.keys(masterLST).map(attrName => {
		return addFile(masterLST[attrName]);
	});

	const message = {
		files: [
			{
				filenames: staticFiles,
				folder: 'dats',
				jobguid: staticTimeUUID,
				label: 'target'
			},
			{
				filenames: destFiles,
				folder: 'dats',
				jobguid: editableTimeUUID,
				label: 'source'
			}
		]
	};
	return message;
}

function delay(t, val) {
	return new Promise(resolve => setTimeout(resolve, t, val));
}

async function getAlignmentStatus(executionId, counter = 0) {
	await delay(2000);
	const response = await fetch(
		`${AIP_URLS.stationalignment}/machine/status/${executionId}`,
		{
			headers: {
				'Content-Type': 'application/json'
			}
		}
	);
	if (!response.ok) {
		throw new Error(`Response status: ${response.status}`);
	}
  const res = (await response.json()) || {};

  let body;
  let output;
  const { status, output: strOutput } = res;

  if (strOutput) {
    output = JSON.parse(strOutput);
  }

  if (output?.body) { 
    body = JSON.parse(output.body);
  }

  if (counter < 120 && status === 'RUNNING') {
		return await getAlignmentStatus(executionId, counter + 1);
	}

	if (status === 'SUCCEEDED' && body !== undefined) {
		return body;
	}

	return undefined;
}

async function downloadResults(url) {
	const response = await fetch(url);
	if (!response.ok) {
		throw new Error(`Response status: ${response.status}`);
	}
	const data = (await response.text()) || '';

	const csv = Papa.parse(data, {
		header: true,
		dynamicTyping: true,
		skipEmptyLines: true
	});

	return csv.data;
}

export const getAlignmentSuggestions = async cisview => {
	const message = getMessage(cisview);

	const response = await fetch(
    `${AIP_URLS.stationalignment}/machine/start`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(message)
		}
  );

	if (!response.ok) {
		throw new Error(`Response status: ${response.status}`);
	}

	const json = await response.json();

	const { executionId } = json;

  const results = (await getAlignmentStatus(executionId)) || {};

	const { matchedPairsUrl } = results;
	if (matchedPairsUrl) {
		const matchedPairsCSV = await downloadResults(matchedPairsUrl);
		return matchedPairsCSV;
	}

	return undefined;
};
